// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar[data-v-3238c422]{width:100%}.sidebar div+div[data-v-3238c422]{margin-top:20px}\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/Sidebar.vue?vue&type=style&index=0&id=3238c422&prod&lang=scss&scoped=true
// module id = 162
// module chunks = 0 1